import { createSlice } from '@reduxjs/toolkit';

import { EMPTY_VALUES } from 'constants/general';

const initialState = {
	regions: EMPTY_VALUES.ARRAY,
	segments: EMPTY_VALUES.ARRAY,
	original: {
		agencies: EMPTY_VALUES.ARRAY,
		notAssignedManagers: EMPTY_VALUES.ARRAY,
		agencyManagersAndSubordinates: EMPTY_VALUES.OBJECT,
	},
	agencies: EMPTY_VALUES.ARRAY,
	notAssignedManagers: EMPTY_VALUES.ARRAY,
	agencyManagersAndSubordinates: EMPTY_VALUES.OBJECT,
	pristineStates: EMPTY_VALUES.OBJECT,
	managerLogin: null,
};

export const marketPlaceAgencies = createSlice({
	name: 'marketPlaceAgencies',
	initialState,
	reducers: {
		saveRegions: (state, { payload }) => ({
			...state,
			regions: payload,
		}),
		saveSegments: (state, { payload }) => ({
			...state,
			segments: payload,
		}),
		saveOriginalValues: (state, { payload }) => ({
			...state,
			original: {
				...state.original,
				...(payload?.areas && { agencies: payload?.areas }),
				...(payload?.notAssignedManagers && { notAssignedManagers: payload?.notAssignedManagers }),
				...(payload?.agencyManagersAndSubordinates && {
					agencyManagersAndSubordinates: payload?.agencyManagersAndSubordinates,
				}),
			},
		}),
		saveAgencies: (state, { payload }) => ({
			...state,
			agencies: payload,
		}),
		saveAgencyManagersAndSubordinates: (state, { payload }) => ({
			...state,
			agencyManagersAndSubordinates: {
				...state.agencyManagersAndSubordinates,
				...payload,
			},
		}),
		resetAgencyManagersAndSubordinates: (state) => ({
			...state,
			agencyManagersAndSubordinates: EMPTY_VALUES.OBJECT,
		}),
		saveNotAssignedManagers: (state, { payload }) => ({
			...state,
			notAssignedManagers: payload,
		}),
		savePristineStates: (state, { payload }) => ({
			...state,
			pristineStates: {
				...state.pristineStates,
				...payload,
			},
		}),
		setManagerLogin: (state, { payload }) => ({
			...state,
			managerLogin: payload,
		}),
		reset: () => initialState,
	},
});

export default marketPlaceAgencies.reducer;
export const REDUCER_NAME = marketPlaceAgencies.name;

export const {
	saveRegions,
	saveSegments,
	saveOriginalValues,
	saveAgencies,
	saveAgencyManagersAndSubordinates,
	resetAgencyManagersAndSubordinates,
	saveNotAssignedManagers,
	savePristineStates,
	setManagerLogin,
	reset,
} = marketPlaceAgencies.actions;
